import { cn } from "@/lib/class-control";

interface ProjectMetadataRowProps {
  label: string;
  value: string | number;
  labelWidth?: string;
  gap?: string;
  size?: "sm" | "md";
  className?: string;
}

export function ProjectMetadataRow({
  label,
  value,
  labelWidth = "252px",
  gap = "23px",
  size = "sm",
  className
}: ProjectMetadataRowProps) {
  const fontSize = size === "sm" ? "text-[12px]" : "text-[16px]";

  return (
    <div
      className={cn(
        "flex items-start justify-end leading-normal text-white",
        className
      )}
      style={{ gap }}
    >
      <p
        className={cn(
          "font-['Plus_Jakarta_Sans'] font-semibold",
          fontSize
        )}
        style={{ width: labelWidth }}
      >
        {label}
      </p>
      <p
        className={cn(
          "font-['Plus_Jakarta_Sans'] font-normal text-right whitespace-pre",
          fontSize
        )}
      >
        {value}
      </p>
    </div>
  );
}
